import React from "react";
import { Card } from "react-bootstrap";
const CustomerReview = ({ email, review, rating }) => {
  return (
    <Card className="my-3">
      <Card.Body>
        <Card.Title>Email: {email}</Card.Title>
        <Card.Text>Comment: {review}</Card.Text>
        <Card.Text>Rating: {rating}</Card.Text>
      </Card.Body>
    </Card>
  );
};
export default CustomerReview;
